/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminApproveCustomPortionRequest } from '../model';
// @ts-ignore
import { AdminAssignCustomPortionRequest } from '../model';
/**
 * AdminSelectionControllerApi - axios parameter creator
 * @export
 */
export const AdminSelectionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {AdminApproveCustomPortionRequest} adminApproveCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCustomPortionRequest: async (userId: string, selectionId: string, adminApproveCustomPortionRequest: AdminApproveCustomPortionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('approveCustomPortionRequest', 'userId', userId)
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('approveCustomPortionRequest', 'selectionId', selectionId)
            // verify required parameter 'adminApproveCustomPortionRequest' is not null or undefined
            assertParamExists('approveCustomPortionRequest', 'adminApproveCustomPortionRequest', adminApproveCustomPortionRequest)
            const localVarPath = `/admin/user-menu/{userId}/selections/{selectionId}/custom-portion/approve`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminApproveCustomPortionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {AdminAssignCustomPortionRequest} adminAssignCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCustomPortionRequest: async (userId: string, selectionId: string, adminAssignCustomPortionRequest: AdminAssignCustomPortionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assignCustomPortionRequest', 'userId', userId)
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('assignCustomPortionRequest', 'selectionId', selectionId)
            // verify required parameter 'adminAssignCustomPortionRequest' is not null or undefined
            assertParamExists('assignCustomPortionRequest', 'adminAssignCustomPortionRequest', adminAssignCustomPortionRequest)
            const localVarPath = `/admin/user-menu/{userId}/selections/{selectionId}/custom-portion/assign`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAssignCustomPortionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCustomPortionRequest: async (userId: string, selectionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('rejectCustomPortionRequest', 'userId', userId)
            // verify required parameter 'selectionId' is not null or undefined
            assertParamExists('rejectCustomPortionRequest', 'selectionId', selectionId)
            const localVarPath = `/admin/user-menu/{userId}/selections/{selectionId}/custom-portion/reject`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"selectionId"}}`, encodeURIComponent(String(selectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSelectionControllerApi - functional programming interface
 * @export
 */
export const AdminSelectionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSelectionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {AdminApproveCustomPortionRequest} adminApproveCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveCustomPortionRequest(userId: string, selectionId: string, adminApproveCustomPortionRequest: AdminApproveCustomPortionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveCustomPortionRequest(userId, selectionId, adminApproveCustomPortionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {AdminAssignCustomPortionRequest} adminAssignCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCustomPortionRequest(userId: string, selectionId: string, adminAssignCustomPortionRequest: AdminAssignCustomPortionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCustomPortionRequest(userId, selectionId, adminAssignCustomPortionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCustomPortionRequest(userId: string, selectionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCustomPortionRequest(userId, selectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSelectionControllerApi - factory interface
 * @export
 */
export const AdminSelectionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSelectionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {AdminApproveCustomPortionRequest} adminApproveCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCustomPortionRequest(userId: string, selectionId: string, adminApproveCustomPortionRequest: AdminApproveCustomPortionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.approveCustomPortionRequest(userId, selectionId, adminApproveCustomPortionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {AdminAssignCustomPortionRequest} adminAssignCustomPortionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCustomPortionRequest(userId: string, selectionId: string, adminAssignCustomPortionRequest: AdminAssignCustomPortionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.assignCustomPortionRequest(userId, selectionId, adminAssignCustomPortionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} selectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCustomPortionRequest(userId: string, selectionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.rejectCustomPortionRequest(userId, selectionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSelectionControllerApi - object-oriented interface
 * @export
 * @class AdminSelectionControllerApi
 * @extends {BaseAPI}
 */
export class AdminSelectionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} userId 
     * @param {string} selectionId 
     * @param {AdminApproveCustomPortionRequest} adminApproveCustomPortionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSelectionControllerApi
     */
    public approveCustomPortionRequest(userId: string, selectionId: string, adminApproveCustomPortionRequest: AdminApproveCustomPortionRequest, options?: AxiosRequestConfig) {
        return AdminSelectionControllerApiFp(this.configuration).approveCustomPortionRequest(userId, selectionId, adminApproveCustomPortionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} selectionId 
     * @param {AdminAssignCustomPortionRequest} adminAssignCustomPortionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSelectionControllerApi
     */
    public assignCustomPortionRequest(userId: string, selectionId: string, adminAssignCustomPortionRequest: AdminAssignCustomPortionRequest, options?: AxiosRequestConfig) {
        return AdminSelectionControllerApiFp(this.configuration).assignCustomPortionRequest(userId, selectionId, adminAssignCustomPortionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} selectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSelectionControllerApi
     */
    public rejectCustomPortionRequest(userId: string, selectionId: string, options?: AxiosRequestConfig) {
        return AdminSelectionControllerApiFp(this.configuration).rejectCustomPortionRequest(userId, selectionId, options).then((request) => request(this.axios, this.basePath));
    }
}

